<template>
    <section class="page-section">
        <v-container v-if="this.$slots['default']">
            <div v-if="this.$slots['title']" class="tit-wrap tit-wrap--lg text-center">
                <h3 v-if="this.$slots['title']" class="tit tit--xxl" data-aos="fade-up" data-aos-delay="100">
                    <slot name="title" />
                </h3>
                <div v-if="this.$slots['text']" class="txt txt--lg" data-aos="fade-up" data-aos-delay="200">
                    <slot name="text" />
                </div>
            </div>
            <div v-if="this.$slots['titleLine']" class="tit-wrap text-center">
                <h3 v-if="this.$slots['titleLine']" class="tit tit--xxl" data-aos="fade-up" data-aos-delay="100">
                    <slot name="titleLine" />
                </h3>
            </div>
             <div v-if="this.$slots['titleLine']" class="tit-wrap text-center">
                <v-divider vertical class="h-100px h-md-200px grey darken-4" data-aos="fade" data-aos-delay="100" />
            </div>
            <slot />
        </v-container>
        <slot v-if="this.$slots['pageSectionImmersive']" name="pageSectionImmersive" />
    </section>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function() {},
    },
};
</script>

<style lang="scss" scoped>
.page-section {
    position: relative;
    padding: var(--page-section-padding-y) 0;
    &--xxs {
        padding: var(--page-section-padding-y-xxs) 0;
    }
    &--xs {
        padding: var(--page-section-padding-y-xs) 0;
    }
    &--sm {
        padding: var(--page-section-padding-y-sm) 0;
    }
    &--first {
        padding-top: var(--contents-padding-top);
        margin-top: calc(var(--contents-padding-top) * -1);
    }
    &--last {
        padding-bottom: var(--contents-padding-bottom);
        margin-bottom: calc(var(--contents-padding-bottom) * -1);
    }
    &__bg {
        position: absolute;
        top: 0;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        z-index: -1;
        display: block;
        width: 100vw;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
}
</style>
